import { render, staticRenderFns } from "./ChangeOrderPatientInfo.vue?vue&type=template&id=4aa50f1b&scoped=true"
import script from "./ChangeOrderPatientInfo.vue?vue&type=script&lang=js"
export * from "./ChangeOrderPatientInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aa50f1b",
  null
  
)

export default component.exports